module.exports = __webpack_public_path__ + "static/media/fire_vest.a4fe3a3a.png";